<template>
	<div>
		<!-- <div>产品中心{{params ? params.id : 0}}</div> -->
		<div class="banner">
			<img :src="pageData.banner" alt="">
			<div class="title">{{pageData.title}}</div>
		</div>
		<!-- 内容容器 -->
		<div class="content-wrapper">
			<!--data0产品名称  描述 -->
			<section class="data0">
				<div class="content">
					<div class="title">{{pageData.data0.title}}</div>
          <div class="detail">
            <template v-for="(desc, d) in handleBrArr(pageData.data0.desc)">
              <div :key="d" v-if="desc">{{desc}}</div>
            </template>
          </div>
					<!-- <div class="detail">{{pageData.data0.desc}}</div> -->
				</div>
			</section>
      <section class="data5" v-show="pageData.data5.show && params.tlId == '1'">
				<div class="content">
					<div class="title border">{{pageData.data5.title}}</div>
					<div class="data5-swiper-box">
						<div class="data5-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in pageData.data5.lists" :key="index">
									<img :src="item.imgUrl" alt="">
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>
			<!-- data1 产品展示 -->
			<section class="data1" v-show="pageData.data1.show && params.tlId == '2'">
				<div class="content">
					<!-- <div class="title">{{pageData.data1.title}}</div> -->
					<div class="detail ">
						<div class="left">
							<img :src="pageData.data1.imgUrl" alt="">
						</div>
						<div class="right">
							<div class="top" v-html="pageData.data1.desc"></div>
							<!-- <div class="item" v-for="(item, index) in pageData.data1.lists" :key="index">
								<div class="sub_title">{{item.sub_title}}</div>
								<div class="text" v-for="(text, index) in item.details" :key="index">{{text}}</div>
							</div> -->
              <div class="more-box" @click="openPage(`/product/details/${pageData.data1.product.id}/${pageData.data1.product.templateId}`, 'product')">查看更多</div>
						</div>
					</div>
				</div>
			</section>
			<section class="data2" v-show="params.tlId == '1' && pageData.data2.show">
				<div class="content">
					<div class="title border">{{pageData.data2.title}}</div>
					<div class="data2-swiper-box">
						<div class="data2-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in data2Swipers" :key="index">
									<div class="swiper-slide-item" v-for="(itemII, II) in item" :key="II">
										<img :src="itemII.imgUrl" alt="" v-if="pageData.data2.showIcon">
										<div class="title">{{itemII.title}}</div>
                    <div class="desc" >
                      <template v-for="(desc, d) in handleBrArr(itemII.desc)">
                        <div :key="d" v-if="desc">{{desc}}</div>
                      </template>
                    </div>
									</div>
								</div>
							</div>
						</div>
						<div class="swiper-wrapper-footer" v-if="pageData.data2.lists.length > 4">
							<div class="swiper-button-prev swiper-btn swiper-left"></div>
							<div class="swiper-button-next swiper-btn swiper-right"></div>
						</div>
					</div>
				</div>
			</section>

			<!-- data4 产品功能 -->
			<!-- <section class="data4" v-show="params.tlId === '1' && pageData.data4.show">
				<div class="content">
					<div class="title border">{{pageData.data4.title}}</div>
					<div class="data4-swiper-box">
						<div class="data4-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in data4Swipers" :key="index">
									<div class="swiper-slide-item" v-for="(itemII, II) in item" :key="II">
										<div class="title">
											<span class="active">{{handleSliceStr(itemII.title, 0, 1)}}</span><span>{{handleSliceStr(itemII.title, 1)}}</span>
										</div>
										<div class="desc">{{itemII.content}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section> -->
			<section class="data6" v-show="params.tlId === '2' && pageData.data6.show">
				<div class="content">
					<div class="title border">{{pageData.data6.title}}</div>
					<div class="lists">
						<img class="item" :src="item.imgUrl" alt="" v-for="(item, index) in pageData.data6.lists" :key="index">
					</div>
				</div>
			</section>

      <!-- data7 -->
			<section class="data7">
				<div class="content">
					<div class="title border">{{pageData.data7.title}}</div>
					<div class="data7-swiper-box">
						<div class="data7-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in data7Swipers" :key="index">
                  <!-- :class="{'active': hoverIndex == II}"  -->
									<div class="swiper-slide-item" @click="openPage(`/product/details/${itemII.id}/${itemII.templateId}`)" :class="{'active': hoverIndex == II}" v-for="(itemII, II) in item" :key="II" @mouseenter="handlerHover(II)" @mouseleave="handlerHover()">
                    <img :src="itemII.thumbnailImgUrl" alt="">
                    <div class="text-box">
                      <div class="title">{{itemII.title}}</div>
                      <div class="desc">{{itemII.desc}}</div>
                    </div>
									</div>
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>

      <!-- data3 图片展示模块1 -->
			<section class="data3" v-show="params.tlId === '1' && pageData.data3.show">
				<div class="content">
					<div class="title border">{{pageData.data3.title}}</div>
					<div class="data3-swiper-box">
						<div class="data3-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" @click="openPage(`/product/details/${item.id}/${item.templateId}`)" v-for="(item, index) in pageData.data3.lists" :key="index">
									<img :src="item.imgUrl" alt="">
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
  import mixins from '@/mixins';
	import eventBus from '@/utils/eventBus';
	import Swiper from 'swiper';
	import { productDetail, productCategoryDetail, getProductList, advantageIconList, imgList, functionPage, bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

	const formDefault = {
		name: '',
		phone: '',
		city: '',
		email: '',
		company: '',
		type: '',
		desc: '',
	};
	export default {
    name: 'productCate',
    mixins: [mixins],
		props: {},
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				activeNav: 'product',
				pageData: {
					banner: '',
					title: '分体式高速大额存取款机',
					data0: {
						show: 1,
						title: '分体式高速大额存取款机',
						desc: 'OKI是全世界第一家开发出循环式存取款一体机的厂商，拥有多达104项技术专利。目前在中国市场销售的存取款一体机产品中，只有极少数厂商在循环机芯及验钞模块上具有自主研发能力和自主知识产权，OKI是其中的技术先驱。核心部件、核心模块采用先进的技术工艺，模块化设计，能够实现各机器部件的快速升级、更换、灵活配置等，具有良好的扩展性能。',
					},
					data1: {
						show: 0,
						imgUrl: '',
						title: '产品优势',
            desc: '',
            product: {},
						lists: []
					},
					data2: {
						show: 0,
						showIcon: 0,
						title: '产品优势',
						lists: [],
					},
					data3: {
						show: 0,
						title: '图片展示模块',
						lists: []
					},
					data4: {
						title: '产品功能',
						lists: []
					},
					data5: {
						show: 0,
						title: '图片展示模块',
						lists: []
					},
					data6: {
						show: 0,
						title: '展示多图',
						lists: []
          },
          data7: {
            show: 0,
            title: '产品展示',
            lists: []
          }
				},
				data2Index: 0,
        params: { type: 'cate' },
        hoverIndex: -1
			};
		},
		components: {},
		created() {
			this.$store.commit('activeNav', 'product');
			this.init();
		},
		watch: {
			$route(to, from) {
				console.log('watch--$route--from==', from.path);//从哪来
				console.log('watch--$route--to==', to.path);//到哪去
				this.init();
			}
		},
		computed: {
			data2Swipers() {
				let swipers = [];
				this.pageData.data2.lists.forEach((d, i) => {
					if (!swipers[Math.floor(i / 4)]) {
						swipers[Math.floor(i / 4)] = [];
					}
					swipers[Math.floor(i / 4)].push(d);
				});
				console.log('swipers==', swipers);
				return swipers;
			},
			data4Swipers() {
				let swipers = [];
				this.pageData.data4.lists.forEach((d, i) => {
					if (!swipers[Math.floor(i / 4)]) {
						swipers[Math.floor(i / 4)] = [];
					}
					swipers[Math.floor(i / 4)].push(d);
				});
				console.log('swipers==', swipers);
				return swipers;
      },
      data7Swipers() {
				let swipers = [];
				this.pageData.data7.lists.forEach((d, i) => {
					if (!swipers[Math.floor(i / 3)]) {
						swipers[Math.floor(i / 3)] = [];
					}
					swipers[Math.floor(i / 3)].push(d);
				});
				console.log('swipers==', swipers);
				return swipers;
			}
		},
		mounted() {
			var data2Swipers = new Swiper('.data2-swiper', {
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data2-swiper-box .swiper-button-next',
					prevEl: '.data2-swiper-box .swiper-button-prev',
				},
			});
			var data3Swipers = new Swiper('.data3-swiper', {
        autoplay: {
					delay: 5000,
					disableOnInteraction: false
        },
        // loop: true,
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data3-swiper-box .swiper-button-next',
					prevEl: '.data3-swiper-box .swiper-button-prev',
				},
			});
			var data4Swipers = new Swiper('.data4-swiper', {
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data4-swiper-box .swiper-button-next',
					prevEl: '.data4-swiper-box .swiper-button-prev',
				},
			});
			var data5Swipers = new Swiper('.data5-swiper', {
        autoplay: {
					delay: 5000,
					disableOnInteraction: false
        },
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data5-swiper-box .swiper-button-next',
					prevEl: '.data5-swiper-box .swiper-button-prev',
				},
      });
      var data7Swipers = new Swiper('.data7-swiper', {
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data7-swiper-box .swiper-button-next',
					prevEl: '.data7-swiper-box .swiper-button-prev',
				},
			});
		},
		methods: {
      openPage(url) {
				if (!url) {
					return;
				}
				window.location.href = url;
			},
			async init() {
				const params = this.$route.params;
				this.params = Object.assign(this.params, params)
				console.log('product--params === ', this.params);
        const res1 = await productCategoryDetail(this.params.id);
				console.log('product--res1 === ', res1);
				// 顶部图片；
				this.productDetail = res1.data.baseData;
				this.pageData.banner = res1.data.baseData.imgUrl;
				this.pageData.title = res1.data.baseData.imgTitle;

				// 描述
				this.pageData.data0.title = res1.data.baseData.title;
				this.pageData.data0.desc = res1.data.baseData.desc;

        // 
        this.pageData.data1.show = res1.data.baseData.isShowMainProduct;
        this.pageData.data1.desc = res1.data.baseData.showMainProductDesc;
        if (this.pageData.data1.show && this.params.tlId == '2') {
          const res1_1 = await productDetail(res1.data.baseData.showMainProductId);
          console.log('productCate--res1_1==', res1_1);
          this.pageData.data1.imgUrl = res1_1.data.baseData.showAdvantageImg;
          this.pageData.data1.product = res1_1.data.baseData;
        }
				// this.pageData.data1.title = res1.data.baseData.showAdvContentModuleTitle;
				// this.pageData.data1.img = res1.data.baseData.showAdvantageImg;
				// this.pageData.data1.desc = res1.data.baseData.showAdvantageDesc;


				// 优势领域 icon
				this.pageData.data2.show = res1.data.baseData.isShowAdvantageIcon;
        this.pageData.data2.showIcon = res1.data.baseData.isShowAdvantageIcon;
        if (this.params.tlId == '1') {
          this.pageData.data2.title = res1.data.baseData.showAdvIconModuleTitle;
          if (res1.data.baseData.isShowAdvantageIcon) {
            this.pageData.data2.lists = await this.advantageIconList();
          } else {
            this.pageData.data2.lists = [];
          }
        }

				// 展示图片模块1
				this.pageData.data3.show = res1.data.baseData.isShowImg1;
        this.pageData.data3.title = res1.data.baseData.showImg1ModuleTitle;
				this.pageData.data3.lists = await this.imgList(1);
				if (this.params.tlId === '1') {
					// 产品功能；
					// this.pageData.data4.show = res1.data.baseData.isShowAdvantageIcon;
					// if (res1.data.baseData.isShowAdvantageIcon) {
          //   const res2 = await this.functionPage();
          //   console.log('productCate--res2==', res2);
            
					// 	this.pageData.data4.lists = res2.list || [];
					// } else {
					// 	this.pageData.data4.lists = [];
					// }

					// 图片展示模块2
					this.pageData.data5.show = res1.data.baseData.isShowImg2;
					this.pageData.data5.title = res1.data.baseData.showImg2ModuleTitle;
					this.pageData.data5.lists = await this.imgList(2);
				} else if (this.params.tlId === '2') {
					// 展示多图；
					this.pageData.data6.show = res1.data.baseData.isShowMoreImg;
					this.pageData.data6.lists = await this.imgList(2, 0);

					// 图片展示模块2
					this.pageData.data5.show = res1.data.baseData.isShowImg2;
					this.pageData.data5.title = res1.data.baseData.showImg2ModuleTitle;
					this.pageData.data5.lists = await this.imgList(3);
        }
        
        const res2  = await this.getProductListData();
        this.pageData.data7.lists = res2.list || [];
				console.log('product--res2 === ', res2);
				console.log('product--this.data7Swipers === ', this.data7Swipers);

				this.$set(this, 'pageData', this.pageData);
				console.log('product--this.pageData==', this.pageData);
			},
			async advantageIconList() {
				const payload = {
					type: this.params.type === 'cate' ? 1 : 2,
					rid: this.params.id,
					templateId: this.params.tlId || 1
				}
				const res = await advantageIconList(payload);
				console.log('product--advantageIconList--res==', res);
				return res.data.baseData;
			},
			async imgList(index = 1, limit = 5) {
				console.log('imgList--limit==', limit);

				let payload = {
					type: this.params.type === 'cate' ? 1 : 2,
					rid: this.params.id,
					templateId: this.params.tlId || 1,
					index: index || 1,
				}
				if (limit) {
					payload.limit = limit;
				}
				const res = await imgList(payload);
				console.log('product--imgList--index==' + index, limit);
				console.log('product--imgList--res==', res);
				return res.data.baseData;
			},
			async functionPage() {
				const payload = {
					type: this.params.type === 'cate' ? 1 : 2,
					rid: this.params.id,
				}
				const res = await functionPage(payload);
				console.log('product--functionPage--res==', res);
				return res.data.baseData;
      },
      async getProductListData() {
        const res = await getProductList({categoryId: this.params.id});
        console.log('getProductListData--res==', res);
        return res.data.baseData;
      },
			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
      },
      handlerHover(index) {
				this.hoverIndex = index;
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},
			handleSliceStr(str, start = 0, end) {
				var str1 = JSON.parse(JSON.stringify(str));
				if (!str) {
					return '';
				}
				if (!end || end > str.length) {
					end = str.length;
				}
				return str1.slice(start, end);
			},
			// changeData2Index(num) {
			//   const max = Math.ceil(this.pageData.data2.lists.length / 4);
			//   console.log('changeData2Index--max==', max);

			//   if (num > 0 && this.data2Index < max) {
			//     this.data2Index += num;
			//   } else if (num < 0 && this.data2Index > 0) {
			//     this.data2Index += num;
			//   }
			// }
		}
	};
</script>

<style scoped lang="scss">
	@import "../common/css/product-details.scss";
</style>



// WEBPACK FOOTER //
// src/pages/productCate.vue